import axios from "axios";

function inferApiOrigin() {
    if (typeof window === "undefined") {
        return null;
    }

    return null;
}

const inferredApiOrigin = inferApiOrigin();

const apiBaseUrl = import.meta.env.DEV
    ? "/api"
    : (import.meta.env.VITE_API_URL ?? (inferredApiOrigin ? `${inferredApiOrigin}/api` : "/api"));

export async function ensureCsrfCookie() {
    const csrfUrl = import.meta.env.DEV
        ? "/sanctum/csrf-cookie"
        : (import.meta.env.VITE_CSRF_URL
            ?? (inferredApiOrigin
                ? `${inferredApiOrigin}/sanctum/csrf-cookie`
                : `${apiBaseUrl.replace(/\/api\/?$/, "")}/sanctum/csrf-cookie`));

    await axios.get(csrfUrl, {
        withCredentials: true,
        withXSRFToken: true,
        xsrfCookieName: "XSRF-TOKEN",
        xsrfHeaderName: "X-XSRF-TOKEN",
        headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
        },
    });
}
